// import React, { useState } from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';
// import './SideBar.css';
// import Logo from '../../assets/images/image 1.png'
// import { RiDashboardHorizontalLine } from "react-icons/ri";
// import { LiaFileInvoiceSolid } from "react-icons/lia";
// import { FaRegRectangleList } from "react-icons/fa6";
// import { PiShoppingBagOpenBold } from "react-icons/pi";
// import { BsPatchCheck } from "react-icons/bs";
// import { IoNotificationsOutline } from "react-icons/io5";
// import { MdOutlineContactSupport } from "react-icons/md";
// import { AiOutlineLogout } from "react-icons/ai";
// import LogoutPopup from 'components/logoutpopup/LogoutPopup';

// function Sidebar() {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [isModalOpen, setModalOpen] = useState(false);

//   const handleLogout = () => {
//     // Perform logout logic here, e.g., clearing user data, redirecting, etc.
//     setModalOpen(false);
//     console.log('User logged out');
//     localStorage.removeItem("user");
//     localStorage.removeItem("accessToken");
//     localStorage.clear();
//   navigation('/')
//   };
//   const navigation = useNavigate()
//   const toggleDrawer = () => {
//     setDrawerOpen(!drawerOpen);
//   };

//   return (
//     <>
//       <div className="menu-icon" onClick={toggleDrawer}>
//         &#9776;
//       </div>
//       <div className={`sidebar ${drawerOpen ? 'open' : ''}`}>
//         <div className="logo">
//           <img src={Logo} style={{height:'100%',width:'100%',objectFit:'contain'}}/>
//          </div>
//         <nav className='navbar-sidebar'>
//           <ul>
//             <li className='li-navbar'>
//               <NavLink to="/become-a-seller/dashboard" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
//               <RiDashboardHorizontalLine style={{fontSize:20,paddingBottom:'2px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}>  Dashboard </p>
               
               

//               </NavLink>
//             </li>
//             <li className='li-navbar'> 
//             <NavLink to="/become-a-seller/invoices" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
//               <LiaFileInvoiceSolid style={{fontSize:22,paddingBottom:'4px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}>  Invoices </p>
               
               

//               </NavLink>
//             </li>
//             <li className='li-navbar'>
//             <NavLink to="/become-a-seller/orders" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
//               <FaRegRectangleList style={{fontSize:18,paddingBottom:'2px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}>  Orders </p>
               
              

//               </NavLink>
//             </li>
//             <li className='li-navbar'>
//             <NavLink to="/become-a-seller/shops" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
//               < PiShoppingBagOpenBold  style={{fontSize:20,paddingBottom:'2px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}>  Shops </p>
               
              

//               </NavLink>
//             </li>
//             <li className='li-navbar'>
//             <NavLink to="/become-a-seller/rating-and-reviews" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
//               < BsPatchCheck   style={{fontSize:19,paddingBottom:'2px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}>  Ratings & Reviews </p>
               
              

//               </NavLink>
//             </li>
//             <li className='li-navbar'>
//             <NavLink to="/become-a-seller/notification" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
//               < IoNotificationsOutline   style={{fontSize:19,paddingBottom:'2px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}>  Notifications </p>
               
              

//               </NavLink>
//             </li>
//           </ul>
//           <ul className='ul-list-bottom'>
           
            
            
//             <li className='li-navbar'>
//             <NavLink to="/become-a-seller/support" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
//               < MdOutlineContactSupport  style={{fontSize:20,paddingBottom:'2px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}> Support </p>
               
              

//               </NavLink>
//             </li>
//             <li className='li-navbar' >
//             <NavLink onClick={() => setModalOpen(true)} to='' end className='navlinkLinkatag'>
//               < AiOutlineLogout   style={{fontSize:19,paddingBottom:'4px'}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag ')} />
//                <p style={{paddingBottom:0}} className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatagnew')}>  Logout </p>
               
              

//               </NavLink>
//         <LogoutPopup isOpen={isModalOpen} 
//         onClose={() => setModalOpen(false)} 
//         onLogout={handleLogout}/>
//             </li>
//           </ul>
//         </nav>
//       </div>
//     </>
//   );
// }

// export default Sidebar;
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './SideBar.css';
import Logo from '../../assets/images/image 1.png'

import { RiDashboardHorizontalLine } from "react-icons/ri";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { FaRegRectangleList } from "react-icons/fa6";
import { PiShoppingBagOpenBold } from "react-icons/pi";
import { BsPatchCheck } from "react-icons/bs";
import { IoNotificationsOutline } from "react-icons/io5";
import { MdOutlineContactSupport } from "react-icons/md";
import { AiOutlineLogout } from "react-icons/ai";
import { VscAccount } from "react-icons/vsc";

import LogoutPopup from 'components/logoutpopup/LogoutPopup';

function Sidebar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);

  const navigation = useNavigate();

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLogout = () => {
    setModalOpen(false);
    localStorage.clear();
    navigation('/');
  };

  return (
    <>
      {/* ✅ Mobile Header */}
      <div className="mobile-header">
        <div className="header-logo">
          <img src={Logo} alt="logo" />
        </div>

        <div className="menu-icon" onClick={toggleDrawer}>
          &#9776;
        </div>
      </div>

      {/* ✅ Overlay */}
      {drawerOpen && <div className="overlay" onClick={toggleDrawer}></div>}

      {/* ✅ Sidebar */}
      <div className={`sidebar ${drawerOpen ? 'open' : ''}`}>

        <div className="logo">
          <img src={Logo} alt="logo" />
        </div>

        <nav className='navbar-sidebar'>
          <ul>
            <li className='li-navbar'>
              <NavLink to="/become-a-seller/dashboard" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <RiDashboardHorizontalLine />
                <p>Dashboard</p>
              </NavLink>
            </li>

            <li className='li-navbar'>
              <NavLink to="/become-a-seller/invoices"  end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <LiaFileInvoiceSolid />
                <p>Invoices</p>
              </NavLink>
            </li>

            <li className='li-navbar'>
              <NavLink to="/become-a-seller/orders" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <FaRegRectangleList />
                <p>Orders</p>
              </NavLink>
            </li>

            <li className='li-navbar'>
              <NavLink to="/become-a-seller/shops" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <PiShoppingBagOpenBold />
                <p>Shops</p>
              </NavLink>
            </li>

            <li className='li-navbar'>
              <NavLink to="/become-a-seller/rating-and-reviews" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <BsPatchCheck />
                <p>Ratings & Reviews</p>
              </NavLink>
            </li>

            <li className='li-navbar'>
              <NavLink to="/become-a-seller/notification"  end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <IoNotificationsOutline />
                <p>Notifications</p>
              </NavLink>
            </li>
            <li className='li-navbar'>
              <NavLink to="/become-a-seller/account" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <VscAccount />
                <p>Account</p>
              </NavLink>
            </li>
          </ul>

          <ul className='ul-list-bottom'>
            <li className='li-navbar'>
              <NavLink to="/become-a-seller/support" end className={({ isActive }) => (isActive ? 'active-link' : 'navlinkLinkatag')}>
                <MdOutlineContactSupport />
                <p>Support</p>
              </NavLink>
            </li>
            

            <li className='li-navbar'>
              <div className="navlinkLinkatag logout-btn" onClick={() => setModalOpen(true)}>
                <AiOutlineLogout />
                <p>Logout</p>
              </div>

              <LogoutPopup
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onLogout={handleLogout}
              />
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
}

export default Sidebar;